
import React, { useState } from "react";
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getUserAccess = async (loginId: string) => {

    try {
        const res = await axios.get(`${API_BASE_URL}/api/Users/ApplicationUsers/${loginId}/Accessdetails`);

        return res.data;
    } catch (error) {
        console.log("@@Error:", error);
        return error;
    }
};